import React, { useContext } from "react";
import { CurrencyContext } from "../components/CurrencyContext";
import '../singapore.css' ;


const curencylink = {

  INR : "https://booking.int2cruises.com/swift/cruise?siid=1237318&lang=1&destinationtype=All&DeparturePorts=SIN&sortColumn=cruiselinePriority&sortOrder=asc",
  SGD : "https://booking.int2cruises.com/swift/cruise?siid=1227501&lang=1&destinationtype=All&DeparturePorts=SIN&sortColumn=cruiselinePriority&sortOrder=asc",
  USD :"https://booking.int2cruises.com/swift/cruise?siid=1228312&lang=1&destinationtype=All&DeparturePorts=SIN&sortColumn=cruiselinePriority&sortOrder=asc"
}

const HeroBanner = () => {
    const currency = useContext(CurrencyContext);
  return (
    <section className="hero-banner">
      <div className="hero-bg" />
      <div className="hero-overlay" />
      
      <div className="hero-content">
        <div className="hero-text-container">
          {/* <span className="hero-badge">Exclusive Offers Available</span> */}
          <h1 className="hero-heading">
            Cruises From 
            <span className="hero-highlight">Singapore</span>
          </h1>
          <p className="hero-description">
            Discover luxury cruises departing from Singapore with exclusive packages and unbeatable offers. From family adventures to romantic getaways.
          </p>
          <div className="hero-buttons">
            {/* <button className="primary-button">
              Explore Special Offers
            </button> */}
            <a href={curencylink[currency.currencyCode]} target="_self" >
            <button variant="outline" className="secondary-button">
              View All Cruises
            </button>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroBanner;
